/* 
 * Export component file to be used on project
*/

import MenuDashboardItem from './MenuDashboardItem'
export default MenuDashboardItem